import { defineComponent as _defineComponent } from 'vue'
import BottomSheet from '@/components/modal/BottomSheet.vue';
import OnboardingDialogContent from '@/components/widgets/onboarding-widget/components/OnboardingDialogContent.vue';
import { Flag } from '@/lib/onboarding/onboardingFunctions';
import { redirect } from '@/router/router';

interface Props {
  value: boolean;
  flag: Flag;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'OnboardingBottomSheet',
  props: {
    value: { type: Boolean },
    flag: null
  },
  emits: ["input", "actionClicked"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', v: boolean): void;
  (e: 'actionClicked'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean;
  flag: Flag;
}




const actionClick = () => {
  redirect(props.flag.actionLink);
  emit('input', false);
  emit('actionClicked');
};

return { __sfc: true,props, emit, actionClick, BottomSheet, OnboardingDialogContent }
}

})